import { useEffect, useState } from "react";
import Bio from "./Bio";
import AddHobbies from "./AddHobbies";
import AddFeatured from "./AddFeatured";
import "./style.css";
import axios from "axios";
import { useSelector } from "react-redux";
import PersonalDetailsPage from "./PersonalDetailsPage";

function IntroIcon({ type }) {
  if (type === "bio") {
    return (
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path
          fill="currentColor"
          d="M7.2 17.5c-1.8 0-3.2-1.5-3.2-3.4 0-2.5 1.9-4.8 4.5-6.3l.8 1.3C7.4 10.3 6.4 11.6 6.4 13c.4-.3.9-.4 1.5-.4 1.5 0 2.6 1 2.6 2.5 0 1.4-1.1 2.4-2.5 2.4h-.8zm9.3 0c-1.8 0-3.2-1.5-3.2-3.4 0-2.5 1.9-4.8 4.5-6.3l.8 1.3c-1.9 1.2-2.9 2.5-2.9 3.9.4-.3.9-.4 1.5-.4 1.5 0 2.6 1 2.6 2.5 0 1.4-1.1 2.4-2.5 2.4h-.8z"
        />
      </svg>
    );
  }
  if (type === "details") {
    return (
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12 12c2.4 0 4.3-1.9 4.3-4.3S14.4 3.4 12 3.4 7.7 5.3 7.7 7.7 9.6 12 12 12zm0 2.1c-3.2 0-9.6 1.6-9.6 4.8v1.7h19.2v-1.7c0-3.2-6.4-4.8-9.6-4.8z"
        />
      </svg>
    );
  }
  if (type === "hobbies") {
    return (
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <circle cx="12" cy="12" r="8.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="4.4" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="1.4" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 3.4l2.2 6.6h7l-5.6 4.1 2.1 6.5L12 16.6 6.3 20.6l2.1-6.5-5.6-4.1h7L12 3.4z"
      />
    </svg>
  );
}

export default function Intro({
  detailss,
  visitor,
  setOthername,
  onEditDetailsOpen,
  profile,
  onPersonalDetailsSaved,
}) {
  const { user } = useSelector((state) => ({ ...state }));
  const [details, setDetails] = useState();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setDetails(detailss);
    setInfos(detailss);
  }, [detailss]);
  const initial = {
    bio: details?.bio ? details.bio : "",
    otherName: details?.otherName ? details.otherName : "",
    job: details?.job ? details.job : "",
    workplace: details?.workplace ? details.workplace : "",
    highSchool: details?.highSchool ? details.highSchool : "",
    college: details?.college ? details.college : "",
    currentCity: details?.currentCity ? details.currentCity : "",
    hometown: details?.hometown ? details.hometown : "",
    relationship: details?.relationship ? details.relationship : "",
    instagram: details?.instagram ? details.instagram : "",
    hobbies: details?.hobbies ? details.hobbies : [],
    featured: details?.featured ? details.featured : [],
  };
  const [infos, setInfos] = useState(initial);
  const [showBio, setShowBio] = useState(false);
  const [showHobbies, setShowHobbies] = useState(false);
  const [showFeatured, setShowFeatured] = useState(false);
  const [max, setMax] = useState(infos?.bio ? 100 - infos?.bio.length : 100);

  const updateDetails = async (partialUpdate = null) => {
    try {
      const updateData = partialUpdate || infos;
      console.log("Updating details:", updateData);

      const finalInfos = partialUpdate ? { ...infos, ...partialUpdate } : infos;

      const { data } = await axios.put(
        `/updateDetails`,
        {
          infos: finalInfos,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      console.log("Update response:", data);
      setShowBio(false);
      setDetails(data);
      setOthername(data.otherName);
      setInfos({
        bio: data.bio || "",
        otherName: data.otherName || "",
        job: data.job || "",
        workplace: data.workplace || "",
        highSchool: data.highSchool || "",
        college: data.college || "",
        currentCity: data.currentCity || "",
        hometown: data.hometown || "",
        relationship: data.relationship || "",
        instagram: data.instagram || "",
        hobbies: data.hobbies || [],
        featured: data.featured || [],
      });
      onPersonalDetailsSaved?.(data);
    } catch (error) {
      console.error("Details update error:", error);
      alert(error.response?.data?.message || "Failed to update details. Please try again.");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInfos({ ...infos, [name]: value });
    setMax(100 - e.target.value.length);
  };

  if (visitor) {
    return null;
  }

  const hasBio = Boolean(details?.bio?.trim());
  const hasHobbies = Boolean(details?.hobbies?.length);
  const hasFeatured = Boolean(details?.featured?.length);
  const hasPersonalDetails = Boolean(
    details?.currentCity ||
      details?.hometown ||
      details?.relationship ||
      details?.family?.length ||
      profile?.bYear
  );

  return (
    <div className="profile_card intro_card">
      <div className="intro_header">
        <div className="profile_card_header">Intro</div>
        <p className="intro_subtitle">Customize your profile</p>
      </div>

      <div className="intro_list">
        <div className={`intro_item ${showBio ? "is_open" : ""}`}>
          {!showBio && (
            <button className="intro_row" type="button" onClick={() => setShowBio(true)}>
              <span className="intro_icon intro_icon_bio">
                <IntroIcon type="bio" />
              </span>
              <span className="intro_meta">
                <span className="intro_title">Bio</span>
                <span className="intro_hint">
                  {hasBio ? "Added" : "Tell people about yourself"}
                </span>
              </span>
              <span className={`intro_pill ${hasBio ? "is_edit" : "is_add"}`}>
                {hasBio ? "Edit" : "Add"}
              </span>
            </button>
          )}
          {showBio && (
            <Bio
              infos={infos}
              max={max}
              handleChange={handleChange}
              setShowBio={setShowBio}
              updateDetails={updateDetails}
              placeholder="Write a short bio"
              name="bio"
            />
          )}
        </div>

        <div className="intro_item">
          <button
            className="intro_row"
            type="button"
            onClick={() => {
              setVisible(true);
              onEditDetailsOpen?.(true);
            }}
          >
            <span className="intro_icon intro_icon_details">
              <IntroIcon type="details" />
            </span>
            <span className="intro_meta">
              <span className="intro_title">Personal Details</span>
              <span className="intro_hint">Hometown, birthday, relationship</span>
            </span>
            <span className={`intro_pill ${hasPersonalDetails ? "is_edit" : "is_add"}`}>
              {hasPersonalDetails ? "Edit" : "Add"}
            </span>
          </button>
        </div>

        {visible && (
          <PersonalDetailsPage
            details={details}
            profile={profile}
            setVisible={(v) => {
              setVisible(v);
              if (!v) onEditDetailsOpen?.(false);
            }}
            onSaved={(data) => {
              setDetails((prev) => ({
                ...prev,
                ...data,
                detailsPrivacy: data.detailsPrivacy || prev?.detailsPrivacy,
                family: data.family || prev?.family,
              }));
              setInfos((prev) => ({
                ...prev,
                currentCity: data.currentCity ?? prev.currentCity,
                hometown: data.hometown ?? prev.hometown,
                relationship: data.relationship ?? prev.relationship,
              }));
              onPersonalDetailsSaved?.(data);
            }}
          />
        )}

        <div className={`intro_item ${showHobbies ? "is_open" : ""}`}>
          {!showHobbies && (
            <button className="intro_row" type="button" onClick={() => setShowHobbies(true)}>
              <span className="intro_icon intro_icon_hobbies">
                <IntroIcon type="hobbies" />
              </span>
              <span className="intro_meta">
                <span className="intro_title">Hobbies</span>
                <span className="intro_hint">
                  {hasHobbies
                    ? `${details.hobbies.length} added`
                    : "Share what you love to do"}
                </span>
              </span>
              <span className={`intro_pill ${hasHobbies ? "is_edit" : "is_add"}`}>
                {hasHobbies ? "Edit" : "Add"}
              </span>
            </button>
          )}
          {showHobbies && (
            <AddHobbies
              hobbies={details?.hobbies || []}
              updateDetails={updateDetails}
              setShowHobbies={setShowHobbies}
            />
          )}
        </div>

        <div className={`intro_item ${showFeatured ? "is_open" : ""}`}>
          {!showFeatured && (
            <button className="intro_row" type="button" onClick={() => setShowFeatured(true)}>
              <span className="intro_icon intro_icon_featured">
                <IntroIcon type="featured" />
              </span>
              <span className="intro_meta">
                <span className="intro_title">Featured</span>
                <span className="intro_hint">
                  {hasFeatured
                    ? `${details.featured.length} added`
                    : "Showcase your work"}
                </span>
              </span>
              <span className={`intro_pill ${hasFeatured ? "is_edit" : "is_add"}`}>
                {hasFeatured ? "Edit" : "Add"}
              </span>
            </button>
          )}
          {showFeatured && (
            <AddFeatured
              featured={details?.featured || []}
              updateDetails={updateDetails}
              setShowFeatured={setShowFeatured}
            />
          )}
        </div>
      </div>
    </div>
  );
}
